module.exports = __webpack_public_path__ + "static/media/doubleTick.375ff91a.svg";